export default __webpack_public_path__ + "static/media/double2.89a3bc1f.jpg";